module.exports = __webpack_public_path__ + "assets/img/one5.b6193fff.png";